import styled from 'styled-components';
import { DOM_MY_ZONE_PAGE } from '../../../../lib/constants';
import TopBottomPadding from '../shared/TopBottomPadding';
import { attachLocale, makeExternalUrl, trackAnalytics } from '../../../../lib/utils';
import Button from '../Button/Button';

const EmptyMyZoneWrapperDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const EmptyHelpTextDiv = styled.div`
  ${({ theme }) => theme.typographyRebrand.body.lg}
  color: ${p => p.theme.c.text.primary};
  text-align: center;
`;

const EmptyStateImage = styled.img`
  width: 288px;
  height: 240px;
`;

const DesktopEmptyHelpTextDiv = styled(EmptyHelpTextDiv)`
  margin-top: ${p => p.theme.unit(4)};
  margin-bottom: ${p => p.theme.unit(5)};
  max-width: ${p => p.theme.unit(86)};
`;

const MobileEmptyHelpTextDiv = styled(EmptyHelpTextDiv)`
  margin-top: ${p => p.theme.unit(2)};
  margin-bottom: ${p => p.theme.unit(5)};
`;

const MyZoneEmptyState = (props) => {
  const {
    emptyStateHelpText,
    emptyStateImageUrl,
    emptyStateImageAltText,
    browseAllText,
    browseAllUrl,
    browseAllTags,
    locale,
    itemType,
    isMobile,
    slug,
  } = props;

  const resolvedBrowseUrl = attachLocale(browseAllUrl, locale);
  const track = trackAnalytics(DOM_MY_ZONE_PAGE, slug, resolvedBrowseUrl, browseAllTags);
  const resolvedEmptyStateImageUrl = makeExternalUrl(emptyStateImageUrl);

  const EmptyHelpTextDivToUse = isMobile ? MobileEmptyHelpTextDiv : DesktopEmptyHelpTextDiv;

  return (
    <TopBottomPadding>
      <EmptyMyZoneWrapperDiv>
        <EmptyStateImage src={resolvedEmptyStateImageUrl} alt={emptyStateImageAltText} />
        <EmptyHelpTextDivToUse isMobile={isMobile}>
          { emptyStateHelpText }
        </EmptyHelpTextDivToUse>
        {browseAllText && browseAllUrl && (
          <Button
            size="large"
            variant="primary"
            buttonText={browseAllText}
            {...track}
          />
        )}
      </EmptyMyZoneWrapperDiv>
    </TopBottomPadding>
  );
};

export default MyZoneEmptyState;
